import type { IconifyIcon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { TicketFilter, TicketView } from '#pie/internal/api/pie-bff';
import { encodeFilters } from '#pie/stores/createFiltersAtom';
import { Card } from '../card/Card';
import { Icon } from '../icon/Icon';
import { SkeletonLines } from '../skeleton-lines/SkeletonLines';
import { Text } from '../text/Text';

interface KpiCardProps {
  bgColor?: string;
  data?: string | number;
  ticketView: TicketView;
  icon: IconifyIcon;
  iconColor?: string;
  isLoading: boolean;
  title: string;
  onClick?: () => void;
}

export const KpiCard = ({
  bgColor,
  data,
  ticketView,
  icon,
  iconColor,
  isLoading,
  title,
  onClick,
}: KpiCardProps) => {
  const { t } = useTranslation();
  return (
    <Link
      to={`/berichtenbox?filters=${encodeFilters<TicketFilter>({ ticketView })}`}
      onClick={onClick}
    >
      <Card className="px-6 py-4 min-h-[124px]" variant="interactive">
        <div className="flex flex-row justify-between items-start">
          <div className="flex flex-col">
            <Text className="text-xl">{title}</Text>
            {isLoading ? (
              <SkeletonLines lines={1} />
            ) : !data ? (
              <Text className="italic text-sm mt-2">
                {t('kpi_card.no_data')}
              </Text>
            ) : (
              <Text variant="display">{data}</Text>
            )}
          </div>
          <div className={`${bgColor} p-2 rounded-md`}>
            <Icon icon={icon} size={32} className={`${iconColor}`} />
          </div>
        </div>
      </Card>
    </Link>
  );
};
